import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
const GetOrderPipelines = graphql(`
  query GetOrderPipelines($orderId: ID!) {
    order {
      get(id: $orderId) {
        pipelines {
          pipeline {
            id
            name
            stages {
              id
              name
            }
          }
          stageId
        }
      }
    }
  }
`);
export default GetOrderPipelines;
